import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const { t } = useI18n();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-soft" data-testid="auth-loading">
        {t("common.loading")}
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
